<script setup>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import moment from "moment";

const props = defineProps({
  lorder: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <Popover as="div" class="relative w-full">
    <PopoverButton
      class="w-full flex items-center p-4 bg-white justify-center space-x-2 rounded-lg shadow-box overflow-hidden focus:outline-none"
    >
      <p class="text-md text-theme-body font-light leading-none">
        Last ordered on
        <span class="font-semibold text-theme-secondary">{{ moment(lorder[0]?.created_at).format("L") }}</span>
      </p>
      <span class="text-theme-body hover:text-theme-dark-shade cursor-pointer"><Icon name="info" class="w-4 h-4 "/></span>
    </PopoverButton>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 sm:scale-95"
      enter-to-class="transform opacity-100 sm:scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 sm:scale-100"
      leave-to-class="transform opacity-0 sm:scale-95"
    >
      <PopoverPanel class="lorder-panel">
        <div class="flex items-center justify-between gap-3 mb-2">
          <p class="text-theme-secondary font-medium">Last Order Details</p>
          <PopoverButton class="text-theme-dark hover:text-theme-secondary cursor-pointer">
            <Icon name="close" class="w-5 h-5" />
          </PopoverButton>
        </div>
        <table class="w-full text-sm font-medium border border-theme-border border-opacity-50 rounded-lg overflow-hidden">
          <thead>
            <tr>
              <th class="text-left text-theme-secondary p-2 pl-0 font-medium">Variant</th>
              <th class="text-left text-theme-secondary p-2 font-medium">Qty</th>
              <th class="text-left text-theme-secondary p-2 font-medium">Date</th>
            </tr>
            <tr v-for="item in lorder" :key="item.id">
              <td class="p-2 pl-0">
                <p class="text-theme-dark-shade font-normal">{{ item.name }}</p>
              </td>
              <td class="p-2 text-center">
                <p class="text-theme-dark-shade font-normal">{{ item.quantity }}</p>
              </td>
              <td class="p-2">
                <p class="text-theme-dark-shade font-normal">{{ moment(item.created_at).format("L") }}</p>
              </td>
            </tr>
          </thead>
        </table>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<style lang="scss">
.lorder-panel {
  top: 56px;
  @apply p-3 sm:origin-top-right fixed sm:absolute right-0 sm:mt-2 left-0 sm:left-auto w-screen sm:w-96 sm:rounded-lg rounded-lg shadow-box overflow-hidden bg-white ring-1 ring-black ring-opacity-5 focus:outline-none sm:top-full z-50 h-full sm:h-auto;
}
</style>
